import React from 'react';
import { Phone, ArrowUpRight } from 'lucide-react';
import { CONTACT } from '../mock';
import Logo from './Logo';

export default function CtaBanner() {
  return (
    <section className="relative py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="relative overflow-hidden rounded-3xl bg-[#49001B] px-6 py-14 md:px-16 md:py-24 text-center">
          <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-96 w-[560px] rounded-full bg-[#ddc390]/25 blur-3xl" />
          <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: 'radial-gradient(#ddc390 1px, transparent 1px)', backgroundSize: '22px 22px' }} />
          <div className="relative">
            <div className="flex justify-center mb-8">
              <Logo variant="mark" className="h-24 md:h-28 w-24 md:w-28 object-contain scale-[2] origin-center opacity-95" />
            </div>
            <div className="text-[12px] uppercase tracking-[0.28em] text-[#ddc390] mb-6">Brand or Movie?</div>
            <h2 className="font-serif-display text-5xl md:text-7xl lg:text-8xl leading-[0.98] tracking-tight text-[#ede2c4]">
              Ready to make an <span className="italic text-[#ddc390]">impact</span>?
            </h2>
            <p className="mt-6 max-w-2xl mx-auto text-[16px] text-[#ede2c4]/75 leading-relaxed">
              Let&rsquo;s discuss how we can bring your vision to life with a marketing strategy that delivers results.
            </p>
            <div className="mt-10 flex items-center justify-center gap-3 flex-wrap">
              <a href={`tel:${CONTACT.phoneRaw}`} className="inline-flex items-center gap-2 rounded-full bg-[#ddc390] px-6 py-3.5 text-[14px] font-semibold text-[#162028] hover:bg-[#ede2c4] transition-colors group">
                <Phone size={16} /> Contact Us
                <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
              <a href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-2 rounded-full border border-[#ede2c4]/25 px-6 py-3.5 text-[14px] font-semibold text-[#ede2c4] hover:bg-[#ede2c4] hover:text-[#162028] transition-colors">
                Send an email
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
